module.exports = __webpack_public_path__ + "96f5846ce95f1cdd8aec5553aaf7bbb7.png";